import type { DateFnsFormat } from '../../models'
import { DateFormat } from '../../models'

import { formatDestinationDate } from './formatDestinationDate'

export const formatDestinationDateRange = ({
  from,
  fromFormat = DateFormat.Standard,
  to,
  toFormat = DateFormat.Standard,
}: {
  from: Date | string
  fromFormat?: DateFnsFormat
  to: Date | string
  toFormat?: DateFnsFormat
}): string => `${formatDestinationDate(fromFormat, from)} - ${formatDestinationDate(toFormat, to)}`
